import React from "react";
import VaultSystem from "./contracts/VaultSystem.json";
import GeneralToken from "./contracts/GeneralToken.json";


// NOTICE (2020-11-02: This JS file has been heavily bombarded by my and NW's attempt to
// Introduce GeneralToken as an item.  It's probably easier to just use delegatecall and bypass this 
// Problem altogether.

class WithdrawWei extends React.Component {
  state = { stackId: null };

  handleClick = e => {
	console.log("hi");
	const { drizzle, drizzleState } = this.props;
	/*
	fetch('./contracts/GeneralToken.json') // This call actually fails to get the file because React preprocesses the URI.
    .then((r) => r.text())
    .then(text  => {
      console.log(text);
    })*/ 
	

	var contractConfig = {
		contractName: "VaultSystem2",
		web3Contract: new drizzle.web3.eth.Contract(this.props.drizzle.contracts.VaultSystem.abi, "0x640a72ceadFF022A01809bc972cE0C61Ef90a28d") 
	};
	
	var events = ['Mint'];

	drizzle.addContract(contractConfig, events);
	
	const dataKey = this.props.drizzle.contracts.VaultSystem2.methods["spxToken"].cacheCall(drizzleState.accounts[0]);
	debugger;
	this.setState({ dataKey });
		
	  var inputInt = document.getElementById("inputIntWeiToWithdraw");    
	  this.setValue(inputInt.value);
	  
  };

  setValue = (weiwithdraw) => {
    const { drizzle, drizzleState } = this.props;
    const contract = drizzle.contracts.VaultSystem;


    // let drizzle know we want to call the `set` method with `value`
    const stackId = contract.methods["withdrawWEI"].cacheSend(weiwithdraw, {
      from: drizzleState.accounts[0]
    });

    // save the `stackId` for later reference
    this.setState({ stackId });
  };

  getTxStatus = () => {
    // get the transaction states from the drizzle state
    const { transactions, transactionStack } = this.props.drizzleState;

    // get the transaction hash using our saved `stackId`
    const txHash = transactionStack[this.state.stackId];

    // if transaction hash does not exist, don't display anything
    if (!txHash) return null;	
    // otherwise, return the transaction status
    return `Transaction status: ${transactions[txHash] && transactions[txHash].status}`;
  };

  render() {
    return (
      <div>
		<hr/>
		<b>This Section is Experimental.  Old withdraw Wei Section </b><br/>
		<div id="frm1">
			Integer number of Weis to Withdraw: <br/> <input type="text" name="inputInt" id="inputIntWeiToWithdraw"/><input type="submit" value="Submit" onClick={this.handleClick}/><br/>
			Note: you must be in margin compliance *after* the Ether withdrawal in order for the transaction to succeed. 
		</div> 
        <div>{this.getTxStatus()}</div>
      </div>
    );
  }
}

export default WithdrawWei;